import { initialState } from "./state"

export default {
  resetCategory: state => {
    const init_state = initialState()
    Object.keys(state).forEach(key => {
      state[key] = init_state[key]
    })
  },
  setName: (state, payload) => (state.name = payload),
  setActive: (state, payload) => (state.active = payload)
}
